<ag-grid-angular #agGrid
                 class="agGrid ag-theme-quartz"
                 [gridOptions]="gridOptions"
                 [context]="context"
                 [rowData]="shadingList"
                 [columnDefs]="columnDefs"
                 [autoGroupColumnDef]="autoGroupColumnDef"
                 [defaultColDef]="defaultColDef"
                 [sideBar]="sideBar"
                 [statusBar]="statusBar"
                 [suppressDragLeaveHidesColumns]="suppressDragLeaveHidesColumns"
                 [rowGroupPanelShow]="rowGroupPanelShow"
                 (gridReady)="gridReady($event)"
                 [rowSelection]="rowSelection"
                 [getContextMenuItems]="shadingListContextMenu"
                 [initialGroupOrderComparator]="initialGroupOrderComparator"
                 [allowContextMenuWithControlKey]="true"
                 (selectionChanged)="onSelectionChanged($event)"
                 (rowDoubleClicked)="onRowDoubleClicked($event)">
</ag-grid-angular>
